package com.bulut.mecitogullari.data.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val name: String,
    val email: String,
    val photoUrl: String? = null,
)
